export default __webpack_public_path__ + "static/media/emailDark.442e3f34.svg";